<div class="text-center">
      Current size: {{ screenSize | uppercase }} ({{ screenSizePx }}px)
    </div>